import Types from "./types";

export default class Dispatcher {
    constructor(dispatch) {
        this.dispatch = dispatch;
    }

    fetchStart = payload => this.dispatch({ type: Types.FETCH_START, payload });

    resetError = () => this.dispatch({ type: Types.RESET_ERROR, payload: {} });
}